import e, { useState as f, useMemo as E } from "react";
import { c as s, t as l } from "./useKeyDown-88662051.mjs";
import { L as k } from "./Link-460da2fc.mjs";
import { I as v, W as _ } from "./Icon-e01b6482.mjs";
import { B as i } from "./useClickOutside-55c64a80.mjs";
import "./LinkContext-0c83848a.mjs";
const H = "company-card", x = "desktop", T = "company-card__header", b = "company-card__header__title", O = "company-card__header__logo", w = "company-card__divider", D = "company-card__services", I = "company-card__services__item", P = "company-card__services__show_button", B = "company-card__services__overlay", R = "company-card__description", W = "company-card__link", A = "company-card__skeleton", U = "skeleton", z = "company-card__skeleton__title", G = "company-card__skeleton__paragraph", M = "company-card__skeleton__link", a = {
  companyCard: H,
  desktop: x,
  companyCardHeader: T,
  companyCardHeaderTitle: b,
  companyCardHeaderLogo: O,
  companyCardDivider: w,
  companyCardServices: D,
  companyCardServicesItem: I,
  companyCardServicesShowButton: P,
  companyCardServicesOverlay: B,
  companyCardDescription: R,
  companyCardLink: W,
  companyCardSkeleton: A,
  skeleton: U,
  companyCardSkeletonTitle: z,
  companyCardSkeletonParagraph: G,
  companyCardSkeletonLink: M
};
function V(n) {
  return n.isLoading ? /* @__PURE__ */ e.createElement(j, null) : /* @__PURE__ */ e.createElement(q, { ...n });
}
function j() {
  return /* @__PURE__ */ e.createElement(
    "article",
    {
      "data-testid": "company-card",
      className: a.companyCard,
      role: "none"
    },
    /* @__PURE__ */ e.createElement("header", { className: a.companyCardHeader }, /* @__PURE__ */ e.createElement("div", { className: a.companyCardSkeletonTitle }), /* @__PURE__ */ e.createElement(
      "div",
      {
        className: s(
          a.companyCardHeaderLogo,
          a.companyCardSkeleton
        )
      }
    )),
    /* @__PURE__ */ e.createElement("div", { className: a.companyCardDivider }),
    /* @__PURE__ */ e.createElement("div", { className: a.companyCardSkeletonParagraph }, Array(4).fill(null).map((n, r) => /* @__PURE__ */ e.createElement("div", { key: r }))),
    /* @__PURE__ */ e.createElement("div", { className: a.companyCardSkeletonParagraph }, Array(9).fill(null).map((n, r) => /* @__PURE__ */ e.createElement("div", { key: r }))),
    /* @__PURE__ */ e.createElement(
      "div",
      {
        className: (a.companyCardLink, a.companyCardSkeletonLink)
      }
    )
  );
}
function q(n) {
  const {
    name: r,
    imageUrl: d,
    services: t = [],
    description: p,
    linkUrl: c,
    i18n: y = {}
  } = n, {
    goToCompanySiteLabel: S = "Go to company site",
    showLessLabel: u = "Show less",
    showMoreLabel: h = "Show more"
  } = y, C = t.length > 4, [o, N] = f(!1), g = () => N((m) => !m), L = E(() => o ? t : t.slice(0, 4), [t, o]);
  return /* @__PURE__ */ e.createElement("article", { "data-testid": "company-card", className: a.companyCard }, /* @__PURE__ */ e.createElement("header", { className: a.companyCardHeader }, /* @__PURE__ */ e.createElement(
    k,
    {
      href: c,
      disableLinkTextStyle: !0,
      className: s(
        a.companyCardHeaderTitle,
        l.textsLeadTextBold
      ),
      target: "_blank"
    },
    r
  ), d ? /* @__PURE__ */ e.createElement(
    "img",
    {
      src: d,
      alt: r,
      className: a.companyCardHeaderLogo,
      loading: "lazy",
      onError: (m) => m.currentTarget.hidden = !0
    }
  ) : null), /* @__PURE__ */ e.createElement("div", { className: a.companyCardDivider }), t.length > 0 ? /* @__PURE__ */ e.createElement("div", null, /* @__PURE__ */ e.createElement("ul", { className: a.companyCardServices }, L.map((m) => /* @__PURE__ */ e.createElement(
    "li",
    {
      key: m,
      className: s(
        a.companyCardServicesItem,
        l.textsCaption
      ),
      "data-clip": C && !o
    },
    m
  )), C && /* @__PURE__ */ e.createElement(
    "div",
    {
      role: "none",
      className: a.companyCardServicesOverlay,
      hidden: o
    }
  )), C && /* @__PURE__ */ e.createElement(
    "button",
    {
      onClick: g,
      className: s(
        a.companyCardServicesShowButton,
        l.textsCaption
      )
    },
    o ? u : h,
    /* @__PURE__ */ e.createElement(
      v,
      {
        icon: o ? _.CHEVRON_UP : _.CHEVRON_DOWN,
        size: 16
      }
    )
  )) : null, /* @__PURE__ */ e.createElement(
    "div",
    {
      className: s(
        a.companyCardDescription,
        l.textsBodyText
      )
    },
    p
  ), /* @__PURE__ */ e.createElement(
    k,
    {
      href: c,
      disableLinkTextStyle: !0,
      className: s(a.companyCardLink),
      target: "_blank"
    },
    S,
    /* @__PURE__ */ e.createElement(v, { icon: _.ARROW_UP_RIGHT, size: 16 })
  ));
}
function $({
  companyCards: n,
  skeletonLoadingCount: r = 3,
  topPadding: d = i.Padding.NONE,
  bottomPadding: t = i.Padding.NONE
}) {
  const p = E(
    () => n ?? F(r),
    [n, r]
  );
  return /* @__PURE__ */ e.createElement(
    i,
    {
      "data-testid": "company-cards",
      topPadding: d,
      bottomPadding: t
    },
    /* @__PURE__ */ e.createElement(i.Content, null, p.map((c, y) => /* @__PURE__ */ e.createElement(V, { key: "name" in c ? c.name : y, ...c })))
  );
}
function F(n) {
  return Array(n).fill({ isLoading: !0 });
}
export {
  $ as default
};
//# sourceMappingURL=CompanyList.js.map
